import reducer from './reducer';
import * as selectors from './selectors';

export const apiStore = {
  selectors,
};

export default reducer;
